var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIneditos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 72,
    viewBox: "6 5 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100:1812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4943 11.7749L13.3999 12.4447L15.4947 14.8552L13.6631 16.2375L12.0337 13.4509L10.4042 16.2375L8.53819 14.8552L10.6032 12.5126L7.50725 11.7749L8.20603 9.56337L11.0701 10.8271L10.8382 7.61248H13.1618L12.7967 10.7718L15.7626 9.52703L16.4943 11.7749ZM18 23V1H6V23L11.9992 16.8883L18 23Z",
    fill: "#FFA435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100:1812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 22,
    fill: "white",
    transform: "translate(6 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIneditos);
export default __webpack_public_path__ + "static/media/logo_ineditos.c61750f89a009a911491facea527c7aa.svg";
export { ForwardRef as ReactComponent };